import { Card, CardContent } from '@mui/material';
import {
  Section,
  Text
} from '@react-email/components';
import { format } from 'date-fns';
import { renderToStaticMarkup } from "react-dom/server";
import './font.css';


export const generateEmailTemplate = (
  clientName,
  budgets,
  emailText,
  hashBudgets,
  emailLanguage,
  defaultDiscount,
  nonRefundableDiscount,
  nonRefundableDiscountPix,
  nonRefundableDiscountCard
) => {
  const emailTextTranslations = {
    pt: {
      '0': 'Entrada',
      '1': 'Saída',
      '2': ' Adultos',
      '3': ' Adulto',
      '4': ' Crianças',
      '5': ' Criança',
      '6': 'crianças de 0 a 3 anos',
      '7': 'criança de 0 a 3 anos',
      '8': 'e',
      '9': 'crianças de 4 a 11 anos',
      '10': 'criança de 4 a 11 anos',
      '11': 'Total do Pacote',
      '12': '(diárias + extras + taxas)',
      '13': '*Valores acima para pagamentos no cartão ou à vista com depósito ou Pix com Política Flexível não possuem desconto',
      '13.5': `*Desconto de ${defaultDiscount}% com a Política Flexível (À vista depósito ou Pix)`,
      '14': `*Desconto de ${nonRefundableDiscountCard}% para política Não Reembolsável (Até 10x no Cartão)`,
      '15': `*Desconto de ${nonRefundableDiscountPix}% para política Não Reembolsável (À vista depósito ou Pix)`,
      '16': 'Total de extras no pacote',
    },
    es: {
      '0': 'Entrada',
      '1': 'Salida',
      '2': ' Adultos',
      '3': ' Adulto',
      '4': ' Niños',
      '5': ' Niño',
      '6': 'niños de 0 a 3 años',
      '7': 'niño de 0 a 3 años',
      '8': 'y',
      '9': 'niños de 4 a 11 años',
      '10': 'niño de 4 a 11 años',
      '11': 'Total del Paquete',
      '12': '(noches + extras + tasas)',
      '13': '*Los valores anteriores para pagos con tarjeta o con depósito o Pix al contado con Política Flexible no tienen descuento',
      // '13.5': `*Descuento del ${defaultDiscount}% con la Política Flexible (depósito o Pix al contado)`,
      '14': `*Descuento del ${nonRefundableDiscountCard}% para la política No Reembolsable (pago con tarjeta)`,
      '15': `*Descuento del ${nonRefundableDiscountPix}% para la política No Reembolsable  (Pix al contado)`,
      '16': 'Total de extras en el paquete',
    },
    en: {
      '0': 'Check-in',
      '1': 'Check-out',
      '2': ' Adults',
      '3': ' Adult',
      '4': ' Children',
      '5': ' Child',
      '6': 'children from 0 to 3 years old',
      '7': 'child from 0 to 3 years old',
      '8': 'and',
      '9': 'children from 4 to 11 years old',
      '10': 'child from 4 to 11 years old',
      '11': 'Total Package',
      '12': '(nights + extras + taxes)',
      '13': '*The above amounts for card payments or full payment by deposit or Pix with Flexible Policy do not have a discount',
      // '13.5': `*${defaultDiscount}% discount with Flexible Policy (full payment by deposit or Pix)`,
      '14': `*${nonRefundableDiscountCard}% discount for Non-Refundable Policy (Card payment)`,
      '15': `*${nonRefundableDiscountPix}% discount for Non-Refundable Policy (full payment by deposit or Pix)`,
      '16': 'Total extras in the package',
    },
  };

  const formatPrice = (price) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price);

  const splitted = emailText && emailText.split('{{{Budget}}}');
  if (!splitted || splitted.length < 2) return;

  const header = splitted[0];
  const body = splitted[1];

  const budgetHtml = (
    <Section>
      {budgets.map((budget, i) => (
        <Card key={i} variant="outlined" style={{ marginTop: i > 0 ? 45 : 0 }}>
          <CardContent style={{ textAlign: 'center' }}>
            <br /><br /><br />

            <Section
              style={{
                textAlign: 'center',
              }}
            >
              <Text
                className="font"
                style={{
                  fontSize: 22,
                  fontWeight: 900,
                  color: '#082B49',
                  textAlign: 'center',
                  margin: 'auto',
                }}
              >
                {emailTextTranslations[emailLanguage]['0']}: {format(budget.check_in, 'dd/MM/yyyy')} {'  '}
                {emailTextTranslations[emailLanguage]['1']}: {format(budget.check_out, 'dd/MM/yyyy')}
              </Text>
            </Section>

            <Text
              className="font"
              style={{
                fontSize: 18,
                fontWeight: 400,
                color: '#082b49',
                textAlign: 'center',
              }}
            >
              {budget.adults_quantity}
              {budget.adults_quantity > 1
                ? emailTextTranslations[emailLanguage]['2']
                : emailTextTranslations[emailLanguage]['3']}{' '}
              - {budget.children_quantity + budget.babies_quantity}
              {(budget.children_quantity + budget.babies_quantity) > 1
                ? emailTextTranslations[emailLanguage]['4']
                : emailTextTranslations[emailLanguage]['5']}
            </Text>

            <Text
              className="font"
              style={{
                fontSize: 18,
                fontWeight: 400,
                color: '#082b49',
                textAlign: 'center',
              }}
            >
              {budget.babies_quantity > 1
                ? `${budget.babies_quantity} ${emailTextTranslations[emailLanguage]['6']}`
                : budget.babies_quantity === 0
                ? ''
                : `${budget.babies_quantity} ${emailTextTranslations[emailLanguage]['7']}`}
              {budget.babies_quantity >= 1 && budget.children_quantity >= 1
                ? ` ${emailTextTranslations[emailLanguage][8]} `
                : ''}
              {budget.children_quantity > 1
                ? ` ${budget.children_quantity} ${emailTextTranslations[emailLanguage]['9']}`
                : budget.children_quantity === 0
                ? ''
                : ` ${budget.children_quantity} ${emailTextTranslations[emailLanguage]['10']}`}
            </Text>

            <Text
              className="font"
              style={{ fontSize: 18, fontWeight: 400, color: '#082b49' }}
            >
              <strong style={{ fontSize: 20, textAlign: 'center' }}>
                {emailTextTranslations[emailLanguage]['11']}
              </strong>
              {emailTextTranslations[emailLanguage]['12']}
            </Text>

            <table style={{ margin: 'auto', width: '600px' }}>
              <tbody>
                {budget.prices.map((price, i) => (
                  <tr
                    key={price.acommodation_description}
                    style={{ backgroundColor: i % 2 === 0 ? '#e5e5e5' : '#fff' }}
                  >
                    <td style={{ width: '180px', fontSize: '18px', color: '#082b49' }}>
                      {price.acommodation_description}
                    </td>
                    <td style={{ width: '100px', fontSize: '18px', color: '#082b49', textAlign: 'right' }}>
                      {formatPrice(price.total_cost_accomodation)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* <Text style={{ fontSize: 16, fontWeight: 400, color: '#082b49' }}>
              {emailTextTranslations[emailLanguage]['13']}
            </Text> */}
            {/* <Text style={{ fontSize: 16, fontWeight: 400, color: '#082b49' }}>
              {emailTextTranslations[emailLanguage]['13.5']}
            </Text> */}
            <Text style={{ fontSize: 16, fontWeight: 400, color: '#082b49' }}>
              {emailTextTranslations[emailLanguage]['14']}
            </Text>
            <Text style={{ fontSize: 16, fontWeight: 400, color: '#082b49' }}>
              {emailTextTranslations[emailLanguage]['15']}
            </Text>

            {budget.extras > 0 && (
              <Text style={{ fontSize: 22, fontWeight: 400, color: '#082b49' }}>
                {emailTextTranslations[emailLanguage]['16']}: {formatPrice(budget.extras)}
              </Text>
            )}
          </CardContent>
        </Card>
      ))}

      {/* <Section style={{ width: '100%', textAlign: 'center', marginTop: 20 }}>
        <Link
          href={`https://paydev.costao.com.br/orcamentos/${hashBudgets}`}
          style={{
            fontSize: 22,
            fontWeight: 400,
            color: '#082b49',
            textDecoration: 'none',
          }}
        >
          Clique aqui para confirmar sua reserva
        </Link>
      </Section> */}
    </Section>
  );

  const budgetHtmlString = renderToStaticMarkup(budgetHtml);
  const email = `${header.replace('{{{nome}}}', clientName)}${budgetHtmlString}${body}`;
  return email;
};
